export const OPEN_PRICE_BOUND = '-1'

const toBound = input => {
  if (input === null || input === undefined) return null
  const text = String(input).trim()
  if (text === '' || text === OPEN_PRICE_BOUND) return null
  const number = Number(text)

  return Number.isFinite(number) && number >= 0 ? number : null
}

export function parsePriceQuery(value) {
  if (typeof value !== 'string') return null

  const [low, high] = value.split(',')
  const range = [toBound(low), toBound(high)]

  return range[0] === null && range[1] === null ? null : range
}

export function priceQueryValue(
  { low, high, lowTouched = false, highTouched = false },
  currentQuery
) {
  const current = parsePriceQuery(currentQuery) || [null, null]
  let from = lowTouched ? toBound(low) : current[0]
  let to = highTouched ? toBound(high) : current[1]

  if (from === null && to === null) return undefined
  if (from !== null && to !== null && from > to) [from, to] = [to, from]

  return [from, to]
    .map(bound => (bound === null ? OPEN_PRICE_BOUND : String(bound)))
    .join(',')
}

const displayed = (bound, fallback, round) => {
  const value = bound ?? toBound(fallback)

  return value === null ? null : round(value)
}

export function priceInputValues(query, defaults) {
  const [low, high] = parsePriceQuery(query) || [null, null]

  return {
    low: displayed(low, defaults?.lowPrice, Math.floor),
    high: displayed(high, defaults?.highPrice, Math.ceil),
  }
}
